import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NoticeOfPrivacyPracticesComponent } from './notice-of-privacy-practices.component';

const routes: Routes = [
	{
		path: '',
		component: NoticeOfPrivacyPracticesComponent,
		data: {
			title: 'Notice of Privacy Practices',
		},
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class NoticeOfPrivacyPracticesRoutingModule {}
